import { __rest } from "tslib";
import React, { useRef } from 'react';
import TitleRightContextMenu from '@web-common/components/UI/ContextMenu/TextContextMenu';
const TitleWithContextMenu = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const ref = useRef(null);
    return (React.createElement(TitleRightContextMenu, { targetNode: ref.current },
        React.createElement("div", Object.assign({ ref: ref }, props), children)));
};
export default TitleWithContextMenu;
